import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { InactivityService } from './inactivity.service';

@Injectable({
  providedIn: 'root'
})
export class StopInactivityServiceGuard implements CanActivate {
  constructor(private inactivityService: InactivityService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Assuming isAuthenticated method checks the current authentication status
    if (!this.isAuthenticated()) {
      this.inactivityService.stopWatching();
      console.log('Stopped inactivity service for unauthenticated route.');
    }
    return true;
  }

  canActivateLogOut(): boolean {
    if (!this.isAuthenticated()) {
      this.inactivityService.stopWatching();
      return false;
    }
    return true;
  }

  private isAuthenticated(): boolean {
    // Implement this method based on how you manage authentication
    return false; // This is just a placeholder
  }
}